import { captureSentry } from '@/utils/sentryHelper';

import { Asset, CaseMetadata, CaseConfig } from '../types';

export const getAssetUrlByPath = (baseUrl: string, assetPath: string): string => {
  return `${baseUrl}${assetPath}`;
};

export const getAssetUrl = (asset: Asset, baseUrl: string): string => {
  // All assets (videos and images) are hosted on LiveLinx API
  // The asset.path already contains the relative path (e.g., "masterclass_videos/video.mp4" or "images/image.jpg")
  return `${baseUrl}${asset.path}`;
};

export const getAssetsByRefs = (refs: string[] | undefined, allAssets: Asset[]): Asset[] => {
  if (!refs || refs.length === 0) return [];
  return refs
    .map((ref) => allAssets.find((a) => a.id === ref))
    .filter((a): a is Asset => a !== undefined);
};

export const getAssetById = (id: string, allAssets: Asset[]): Asset | undefined => {
  return allAssets.find((a) => a.id === id);
};

export const fetchCaseIntroVideoUrl = async (metadata: CaseMetadata): Promise<string | null> => {
  try {
    const response = await fetch(metadata.configUrl);
    if (!response.ok) return null;

    const caseConfig = (await response.json()) as CaseConfig;
    const introVideoRef = caseConfig.masterclass?.caseIntroVideoRef;

    if (!introVideoRef) return null;

    const asset = caseConfig.assets.find((a) => a.id === introVideoRef);
    if (!asset) return null;

    return getAssetUrl(asset, metadata.assetsBaseUrl);
  } catch (error) {
    console.error('Error fetching case intro video:', error);
    captureSentry({
      title: 'Failed to fetch case intro video',
      error,
      detail: { caseId: metadata.id, configUrl: metadata.configUrl },
    });
    return null;
  }
};
